import { appBottomClearanceClass, publicFormColumnMinHeightClass } from "@/components/common/appBottomClearance";

/**
 * Public form routes pad the top (1rem, 1.5rem from md) and use the shared
 * bottom clearance so the footer never sits on the screen edge.
 * The column fills the viewport inside that padding. Taller content grows
 * the page, and the footer scrolls with it.
 */
export const publicFormRoutePaddingClass = `pt-4 md:pt-6 ${appBottomClearanceClass}`;

export const formPageColumnClass = `flex flex-col ${publicFormColumnMinHeightClass}`;

/**
 * Padded route shell inside the app scroll area.
 * At least fills the scrollport so a short page pins the footer, and grows with
 * the page so the bottom padding stays under the buttons after you scroll.
 * flex-1 would lock this box to the scrollport: a long page then scrolls past
 * that padding and the buttons sit flush with the bottom.
 */
export const formPageRouteShellClass = "flex flex-col min-h-full shrink-0";

/**
 * Column inside the route shell. Fills leftover height so the footer sits at
 * the bottom on short pages. flex-1 only: in the app's flex column chain the
 * parent height is definite, so min-h-full would ask for the parent's whole
 * height on top of anything above it (e.g. the journey progress bar) and push
 * the footer below the fold.
 */
export const formPageShellFillClass = "flex flex-col flex-1";

export const formPageFooterFrameClass = "footer-actions-frame shrink-0";

/** Clears the default footer margin so the route padding is the space under the buttons. */
export const formPageFooterActionsClass = "!mb-0 pt-2 footer-actions";
